export default __webpack_public_path__ + "static/media/columnlightning.4cd4c576.png";